import React from "react";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import classNames from "classnames";

import HeaderCopy from "./HeaderCopy";
import ContentForm from "./ContentForm";

import "../styles/components/HeaderContent.scss";

const HeaderContent = ({ header }) => {
    const { title, buttons, copy, form } = header;

    const buttonComponents = buttons?.map(button => {
        const buttonProps = {
            key: button.url,
            variant: `${button.outlineStyle ? "outline-" : ""}${button.color}`,
            size: "lg",
            className: classNames("m-2", {
                "outline-button": button.outlineStyle,
            }),
        };

        if (button.disabled) {
            buttonProps.href = button.url;
            buttonProps.rel = "noreferrer";
            buttonProps.disabled = true;
        } else if (button.url.startsWith("/")) {
            buttonProps.as = Link;
            buttonProps.to = button.url;
        } else {
            buttonProps.as = "a";
            buttonProps.href = button.url;
        }

        return <Button {...buttonProps}>{button.label}</Button>;
    });

    return (
        <>
            {title && <HeaderCopy title={title} lead={copy} />}
            {buttons?.length && (
                <div className="d-flex flex-wrap mb-2 header-buttons">
                    {buttonComponents}
                </div>
            )}
            {form && <ContentForm {...form} headerForm />}
        </>
    );
};

HeaderContent.propTypes = {
    header: PropTypes.shape({
        title: PropTypes.shape({ raw: PropTypes.string }),
        lead: PropTypes.shape({ raw: PropTypes.string }),
        buttons: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string.isRequired,
                label: PropTypes.string.isRequired,
                color: PropTypes.string.isRequired,
                url: PropTypes.string.isRequired,
                outlineStyle: PropTypes.bool,
                openNewTab: PropTypes.bool,
                disabled: PropTypes.bool,
            })
        ),
        forms: PropTypes.shape({
            formType: PropTypes.string,
            lead: PropTypes.shape({ raw: PropTypes.string }),
            formStyle: PropTypes.string,
            downloadUrl: PropTypes.string,
        }),
    }),
};

export default HeaderContent;
